import { useLanguage } from "@/i18n/LanguageContext";

export default function CtaBanner() {
  const { t } = useLanguage();
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-[1080px] mx-auto px-4 md:px-6">
        <div className="bg-accent rounded-xl py-16 md:py-[100px] px-6 md:px-12 text-center">
          <h3 className="text-xl md:text-2xl font-bold text-white mb-6">
            {t("serviceAreas.ctaBannerH3")}
          </h3>
          <a
            href="tel:+17863774452"
            className="inline-flex items-center gap-2 bg-white text-accent px-7 py-3 text-sm font-bold rounded-md hover:bg-[#fefce8] transition-colors whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line" />
            </span>
            {t("serviceAreas.ctaBannerBtn")}
          </a>
        </div>
      </div>
    </section>
  );
}